import { render, staticRenderFns } from "./ConsentAgreementForm.vue?vue&type=template&id=6157a430&"
import script from "./ConsentAgreementForm.vue?vue&type=script&lang=js&"
export * from "./ConsentAgreementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports